import { render, staticRenderFns } from "./_page-title.vue?vue&type=template&id=5624c5f3&scoped=true&"
import script from "./_page-title.vue?vue&type=script&lang=js&"
export * from "./_page-title.vue?vue&type=script&lang=js&"
import style0 from "./_page-title.vue?vue&type=style&index=0&id=5624c5f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624c5f3",
  null
  
)

export default component.exports